import { Injectable, Injector } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';
import { HttpService } from 'projects/core/src/public-api';
import { FeedBackType } from './feedback-type';
import { Any } from 'json2typescript';
import { FileService } from 'projects/core/src/lib/misc/data/file/file.service';
import { ProjectFile } from '../../project-misc/data/project/project-file';
import { HttpEvent } from '@angular/common/http';


@Injectable({
    providedIn: 'root',
})
export class FeedBackService extends HttpService {

    constructor(
        protected injector: Injector,
        protected fileService: FileService
    ) {
        super(injector);
    }

    getFeedBackTypes(): Observable<FeedBackType[]> {
        return this.getData(`/feedback/types`, FeedBackType);
    }

    getFeedBackPriorities(): Observable<string[]> {
        return this.doHttpGet<string[]>(`/feedback/priorities`)
    }

    sendFeedBackFiles(files: File[]): Observable<HttpEvent<string>> {
        return this.fileService.postFile<string>(`/feedback/attachments`, 'files', files);
    }

    sendFeedBack(feedBack: any): Observable<any> {
        return this.postData(`/feedback`, feedBack, Any);
    }

}